export default __webpack_public_path__ + "static/media/hn-unten_rotate.c9e386b6.png";